import { INSURANCE_TYPE_CASH, INSURANCE_TYPE_INSURANCE, INSURANCE_TYPE_CASH_AND_INSURANCE } from 'constants/common';

export const PaymentMethodOptions = [
    { label: 'Accept insurance only', value: INSURANCE_TYPE_INSURANCE },
    { label: 'Cash pay only', value: INSURANCE_TYPE_CASH },
    { label: 'Both insurance and cash', value: INSURANCE_TYPE_CASH_AND_INSURANCE },
];
